interface Props {
  skip: number;
  take: number;
  total: number;
  onPage: (skip: number) => void;
}

export function Pagination({ skip, take, total, onPage }: Props) {
  const start = total === 0 ? 0 : skip + 1;
  const end = Math.min(total, skip + take);
  const page = Math.floor(skip / take) + 1;
  const totalPages = Math.max(1, Math.ceil(total / take));
  const canPrev = skip > 0;
  const canNext = end < total;

  return (
    <div className="flex flex-col gap-2 mt-3 text-[0.8125rem] sm:flex-row sm:items-center sm:justify-between">
      <span className="text-muted-slate">
        Showing <strong>{start}</strong>–<strong>{end}</strong> of <strong>{total}</strong>
      </span>
      <div className="flex items-center gap-2">
        <button
          type="button"
          className="brand-btn brand-btn-secondary brand-btn-sm flex-1 sm:flex-initial"
          disabled={!canPrev}
          onClick={() => onPage(Math.max(0, skip - take))}
          aria-label="Previous page"
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M15 18l-6-6 6-6" />
          </svg>
          Prev
        </button>
        <span
          className="text-muted-slate tabular-nums"
          style={{
            fontVariantNumeric: 'tabular-nums',
            fontSize: '0.75rem',
            backgroundColor: 'var(--color-card-fill)',
            padding: '0.25rem 0.625rem',
            borderRadius: 'var(--radius-sm)',
            border: '1px solid var(--color-divider)',
          }}
        >
          {page} / {totalPages}
        </span>
        <button
          type="button"
          className="brand-btn brand-btn-secondary brand-btn-sm flex-1 sm:flex-initial"
          disabled={!canNext}
          onClick={() => onPage(skip + take)}
          aria-label="Next page"
        >
          Next
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M9 18l6-6-6-6" />
          </svg>
        </button>
      </div>
    </div>
  );
}
